import { useGlobalContent } from "@app/[locale]/GlobalContentProvider";
import { useAuth } from "@lib/auth/useAuth";
import { ACTIVE_CONSENTS_TYPE } from "@lib/constants/consents";
import { createAccountPage, eccoKollektivePage } from "@lib/constants/pagePaths";
import { useGetMyProfile } from "@store/hooks";
import { isEmpty } from "lodash-es";
import { useLocale } from "next-intl";
import { usePathname } from "next/navigation";

export const useNewsletterFooterState = () => {
    const locale = useLocale();
    const pathname = usePathname();
    const { siteSettings } = useGlobalContent();
    const { isLoggedIn } = useAuth();
    const { data } = useGetMyProfile();

    const newsletterPolicy = siteSettings.auth.newsletter;
    const newsletterFooterHiddenPages = [
        createAccountPage[locale],
        createAccountPage["en"],
        eccoKollektivePage[locale],
        eccoKollektivePage["en"],
    ].filter(Boolean);
    const isNewsletterFooterHidden = newsletterFooterHiddenPages.some((path) =>
        pathname.includes(path)
    );
    const isNewsletterPolicyMissing =
        !newsletterPolicy || isEmpty(Object.values(newsletterPolicy).filter(Boolean));
    const hasNewsletterConsent =
        isLoggedIn && data?.activeConsentTypes?.includes(ACTIVE_CONSENTS_TYPE.NEWSLETTER);
    const isNewsletterSignupAvailable = !isNewsletterPolicyMissing && !hasNewsletterConsent;

    return {
        shouldRenderNewsletterFooter: !isNewsletterFooterHidden && isNewsletterSignupAvailable,
    };
};
